import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "page-section tab-section" }
const _hoisted_2 = { class: "section-block" }
const _hoisted_3 = { class: "tab-block" }
const _hoisted_4 = { class: "tab-menu_inline" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "page-section beige-bkg" }
const _hoisted_7 = { class: "team-eval-results-block" }

import { ref, onMounted } from "vue";
interface Tab {
  title: string;
  key: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TabbedPageLayout',
  props: {
    tabs: {},
    contentContainerClass: {}
  },
  setup(__props: any) {

const props = __props;



const activeTab = ref<string>();
onMounted(() => {
  activeTab.value = props.tabs[0]?.key;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "general-block")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
            return (_openBlock(), _createElementBlock("button", {
              key: tab.key,
              class: _normalizeClass(["toggle-btn", { 'active': activeTab.value === tab.key }]),
              onClick: ($event: any) => (activeTab.value = tab.key)
            }, _toDisplayString(tab.title), 11, _hoisted_5))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _renderSlot(_ctx.$slots, "tab-content-container", {}, () => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
            return _withDirectives((_openBlock(), _createElementBlock("section", {
              key: tab.key
            }, [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _renderSlot(_ctx.$slots, tab.key)
              ])
            ])), [
              [_vShow, activeTab.value === tab.key]
            ])
          }), 128))
        ])
      ])
    ])
  ], 64))
}
}

})